module.exports = __webpack_public_path__ + "static/img/bg-id.910b1534.png";